// extracted by mini-css-extract-plugin
export default {"wrapper":"Gallery_wrapper__IXhcJ"};